import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  mostrarCampoTitulo(event) {
    event.preventDefault()

    // Ocultar el mensaje de advertencia completo
    const alertBox = event.currentTarget.closest('.rnk-Flash-alert')
    if (alertBox) {
      alertBox.classList.add('hidden')
    }

    // Mostrar el campo de título
    const campoTitulo = document.getElementById('campo-titulo')
    if (campoTitulo) {
      campoTitulo.classList.remove('hidden')
    }
  }
}
